import React from 'react';
import { lighten, makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';


const ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: '#9600BF',
  },
  barColorPrimary: {
    backgroundColor: '#D6BAE8',
  },
})(LinearProgress);

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function LinearLoading() {
  const classes = useStyles();

  return (
    <div className={`linear-progress ${classes.root}`}>
      <ColorLinearProgress className={classes.margin} />
     
    </div>
  );
}